/**
 * Calculates the total header offset needed for anchor navigation
 * Includes both main header and secondary header (if present)
 * @returns Total offset in pixels (main header + secondary header)
 */
export function getTotalHeaderOffset(): number {
  if (typeof window === 'undefined') return 0

  // Get main header offset
  const mainHeaderOffset =
    getComputedStyle(document.documentElement).getPropertyValue('--header-offset') ||
    getComputedStyle(document.documentElement).getPropertyValue('--header-height')
  const mainHeader = parseFloat(mainHeaderOffset?.replace('px', '') || '0')

  // Get secondary header height (if exists)
  const secondaryHeaderHeight =
    getComputedStyle(document.documentElement).getPropertyValue('--secondary-header-height')
  const secondaryHeader = parseFloat(secondaryHeaderHeight?.replace('px', '') || '0')

  const total =
    (Number.isFinite(mainHeader) ? mainHeader : 0) + (Number.isFinite(secondaryHeader) ? secondaryHeader : 0)

  return total
}

